import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Field, reduxForm, formValueSelector } from "redux-form";

import "./NewRequest.css"

import history from "../../../../history";
import { getReasons } from "../../../../actions/absenceActions";
import { getOccasions } from "../../../../actions/occasionsActions";
import { newRequest } from "../../../../actions/requestActions";
import { getReport } from "../../../../actions/workingTimeActions";

import Form from "../../../CustomViews/Form";

const RequestForm = reduxForm({ form: "requestForm" })(Form);

class NewRequest extends React.Component {
    constructor(props) {
        super(props);

        this.rerenderFunction = null;
        this.reportMonth = "none";
    }

    componentDidMount() {
        if (this.props.currentUser.ouID === null) history.push("/unassigned");
        else {
            this.props.getReasons();
            this.props.getOccasions();
        }
    }

    componentDidUpdate() {
        if (this.rerenderFunction) this.rerenderFunction();
        if (+this.props.forMonth === this.getMonth(true) && this.reportMonth !== "current") {
            this.reportMonth = "current";
            this.props.getReport(this.props.currentUser.userID, this.reportMonth);
        } else if (+this.props.forMonth === this.getMonth(false) && this.reportMonth !== "previous") {
            this.reportMonth = "previous";
            this.props.getReport(this.props.currentUser.userID, this.reportMonth);
        } else if (+this.props.forMonth !== this.getMonth(true) && +this.props.forMonth !== this.getMonth(false) && this.reportMonth !== "none") {
            this.reportMonth = "none";
        }
    }

    getMonth = current => {
        const date = new Date();
        const month = date.getMonth();
        return current ? month + 1 : (month === 0 ? 12 : month);
    };

    formatValue = value => `${value < 0 ? "-" : ""}${Math.floor(Math.abs(value))}:${Math.round(60 * (Math.abs(value) % 1)) < 10 ? "0" : ""}${Math.round(60 * (Math.abs(value) % 1))}`;

    isPast = (type, renderError) => {
        if (type === "date" && this.props.dateFrom && (new Date(`${this.props.dateFrom} 00:00`) < new Date(`${new Date().toDateString()} 00:00`)))
            return renderError({ field: "dateFrom", message: ["Wprowadzono datę z przeszłości"] }, true);
        else if (type === "time" && this.props.dateFrom && this.props.timeFrom && (new Date(`${this.props.dateFrom} ${this.props.timeFrom}`) < new Date()))
            return renderError({ field: "timeFrom", message: ["Wprowadzono czas z przeszłości"] }, true);
    };

    onSubmit = (formValues, onFormError) => {
        if (+formValues.absenceID === -1 || +formValues.absenceID === 30) formValues.dateTo = formValues.dateFrom;
        this.props.newRequest(formValues, onFormError);
    };

    renderOptions = (type) => {
        return (
            <React.Fragment>
                <option />
                {type === "reasons" ? 
                    this.props.reasons.map(absence => absence.active === 1 ? <option key={absence.absenceID} value={absence.absenceID}>{absence.name}</option> : null) :
                    this.props.occasions.map(occasion => <option key={occasion.occasionID} value={occasion.occasionID}>{occasion.occasionName}</option>)
                }
            </React.Fragment>
        );
    };

    renderFieldError = (name, formErrors, renderError) => {
        const error = formErrors.filter(err => err.field === name)[0];
        return renderError(error);
    };

    renderFields = (_, __, ___, renderInput, formErrors, renderError) => {
        return (
            <React.Fragment>
                <div className="ui segments">
                    <div className="ui segment">
                        <div className="ui header">
                            <i className="file alternate icon"></i>
                            Nowy wniosek
                        </div>
                    </div>
                    <div className="ui segment">
                        <div className="ui grid">
                            <div className="three columns row">
                                <div className="column">
                                    <div className="content">
                                        <b>Przyczyna absencji</b><br />
                                        <Field type="select" name="absenceID" component="select" placeholder="Wybierz przyczynę...">
                                            {this.renderOptions("reasons")}
                                        </Field>
                                        {this.renderFieldError("absenceID", formErrors, renderError)}
                                    </div>
                                </div>
                                {+this.props.absenceID === 8 ? (
                                    <div className="column">
                                        <div className="content">
                                            <b>Okoliczność</b><br />
                                            <Field type="select" name="occasionID" component="select" placeholder="Wybierz okoliczność...">
                                                {this.renderOptions("occasions")}
                                            </Field>
                                            {this.renderFieldError("occasionID", formErrors, renderError)}
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                            <div className="three columns row">
                                <div className="column">
                                    <div className="content">{+this.props.absenceID === -1 ? (
                                        <React.Fragment>
                                            <b>W dniu:</b><br />
                                            <Field type="date" name="dateFrom" component={(input) => renderInput(input, false)} placeholder="W dniu..." />
                                            {this.renderFieldError("dateFrom", formErrors, renderError)}
                                            {this.isPast("date", renderError)}
                                        </React.Fragment>
                                    ) : <b>W dniach:</b>}</div>
                                </div>
                            </div>
                            <div className="three columns row">
                                <div className="column">
                                    <div className="content">
                                        <b>Od:</b><br />
                                        {+this.props.absenceID === -1 ? (
                                            <React.Fragment>
                                                <Field type="time" name="timeFrom" component={(input) => renderInput(input, false)} placeholder="Od godziny..." />
                                                {this.renderFieldError("timeFrom", formErrors, renderError)}
                                                {this.isPast("time", renderError)}
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <Field type="date" name="dateFrom" component={(input) => renderInput(input, false)} placeholder="Od dnia..." />
                                                {this.renderFieldError("dateFrom", formErrors, renderError)}
                                                {this.isPast("date", renderError)}
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                                <div className="column">
                                    <div className="content">
                                        <b>{+this.props.absenceID === 30 ? "Przez:" : "Do:"}</b><br />
                                        {+this.props.absenceID === -1 ? (
                                            <React.Fragment>
                                                <Field type="time" name="timeTo" component={(input) => renderInput(input, false)} placeholder="Do godziny..." />
                                                {this.renderFieldError("timeTo", formErrors, renderError)}
                                            </React.Fragment>
                                        ) : +this.props.absenceID === 30 ? (
                                            <React.Fragment>
                                                <Field type="select" name="dayCount" component="select" placeholder="Wybierz liczbę dni...">
                                                <option />
                                                <option value="7">7 dni</option>
                                                <option value="14">14 dni</option>
                                            </Field>
                                            {this.renderFieldError("dayCount", formErrors, renderError)}
                                            </React.Fragment>
                                        ) : (
                                            <React.Fragment>
                                                <Field type="date" name="dateTo" component={(input) => renderInput(input, false)} placeholder="Do dnia..." />
                                                {this.renderFieldError("dateTo", formErrors, renderError)}
                                            </React.Fragment>
                                        )}
                                    </div>
                                </div>
                                <div className="column">
                                    <div className="content">{+this.props.absenceID === -1 ? (
                                        <React.Fragment>
                                            <b>Za miesiąc:</b><br />
                                            <Field type="select" name="forMonth" component="select" placeholder="Wybierz miesiąc...">
                                                <option />
                                                <option value="1">Styczeń</option>
                                                <option value="2">Luty</option>
                                                <option value="3">Marzec</option>
                                                <option value="4">Kwiecień</option>
                                                <option value="5">Maj</option>
                                                <option value="6">Czerwiec</option>
                                                <option value="7">Lipiec</option>
                                                <option value="8">Sierpień</option>
                                                <option value="9">Wrzesień</option>
                                                <option value="10">Październik</option>
                                                <option value="11">Listopad</option>
                                                <option value="12">Grudzień</option>
                                            </Field>
                                            {this.renderFieldError("forMonth", formErrors, renderError)}
                                        </React.Fragment>
                                    ) : null}</div>
                                </div>
                            </div>
                            {+this.props.absenceID === -1 && this.props.forMonth !== undefined ? (
                                <div className="row">
                                    <div className="column">
                                        <div className="ui warning message">Liczba nadgodzin w wybranym miesiącu: {
                                            ((+this.props.forMonth === this.getMonth(true) || +this.props.forMonth === this.getMonth(false)) && this.props.report.reportID !== undefined) ?
                                            this.formatValue(this.props.report.availableOvertime) :
                                            "brak danych"
                                        }</div>
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                    <div className="ui segment">
                        <div className="content">Data złożenia <b>{new Date().toLocaleDateString("en-CA")}</b></div>
                    </div>
                </div>
                {+this.props.absenceID > 0 && this.props.reasons.find(reason => reason.absenceID === +this.props.absenceID).attachmentRequired === 1 ? (
                    <div className="ui tertiary yellow segment">
                        <div className="ui middle aligned grid">
                            <div className="column">
                                <div className="content">Ten wniosek wymaga dostarczenia załącznika</div>
                            </div>
                        </div>
                    </div>
                ) : null}
                <button className="ui button primary">Zatwierdź</button>
            </React.Fragment>
        );
    };

    getRerenderFunction = (rerenderFunction) => this.rerenderFunction = rerenderFunction;

    render() {
        return (
            <React.Fragment>
                <div className="new-request-component ui container">
                    <div className={`ui ${(this.props.currentUser.isSupervisor || this.props.currentUser.admin === 1) && this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : 
                    !this.props.currentUser.isSupervisor && this.props.currentUser.ouID !== +process.env.REACT_APP_HR_OU_ID && this.props.currentUser.admin !== 1 ? "two" : "three"} item menu`}>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <Link to="/requests/hr/pending" className="item">
                                <div className="content">Wnioski do kadr</div>
                            </Link>
                        ) : null}
                        {this.props.currentUser.isSupervisor || this.props.currentUser.admin === 1 ? (
                            <Link to={`/requests/${this.props.currentUser.isSupervisor ? "pending" : "all"}`} className="item">
                                <div className="content">Wnioski pracowników</div>
                            </Link>
                        ) : null}
                        <Link to="/requests/my" className="item">
                            <div className="content">Moje wnioski</div>
                        </Link>
                        <Link to="/requests/new" className="active item">
                            <div className="content">Nowy wniosek</div>
                        </Link>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        <RequestForm getRerenderFunction={this.getRerenderFunction} onSubmit={this.onSubmit} renderFields={this.renderFields} />
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    reasons: state.absence.reasons,
    occasions: state.occasions.list,
    report: state.workingTime.report,
    absenceID: formValueSelector("requestForm")(state, "absenceID"),
    dateFrom: formValueSelector("requestForm")(state, "dateFrom"),
    timeFrom: formValueSelector("requestForm")(state, "timeFrom"),
    forMonth: formValueSelector("requestForm")(state, "forMonth")
});

export default connect(mapStateToProps, { getReasons, getOccasions, newRequest, getReport })(NewRequest);